import PropTypes from "prop-types";
import { TextField, Typography } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import useCrud from "../../../hooks/useCrud";
import { LoadingButton } from "../../Loading";
import { ACCOUNT_GROUP_TYPE, AccountGroupPropTypes } from "../../../utils/financialHelper";

const SelectGrupoContabil = ({ setValues, accountGroup, isDelete: isDisabled, type = ACCOUNT_GROUP_TYPE.OUTCOME, isRequired = true }) => {
  const defaultValues = {
    id: 0,
    name: "",
    classification: "0",
    type,
  };

  const {
    isLoading,
    items: accountGroups,
  } = useCrud('/account-groups', defaultValues, 'SelectGrupoContabil');

  const autoCompleteChange = (e, newValue) => {
    setValues(prev => ({
      ...prev,
      accountGroupId: newValue ? newValue.id : null,
      accountGroup: newValue,
    }))
  }

  return (
    <>
      {
        isLoading ? (
          <Typography variant="subtitle1">
            Carregando grupos contábeis...
            <LoadingButton />
          </Typography>
        ) : (
          <>
            <Autocomplete
              id="accountGroup"
              options={accountGroups.filter(option => option?.type === type)}
              getOptionLabel={(option) => `(${option?.classification}) ${option?.name}`}
              value={accountGroups.find(option => option?.id === accountGroup?.id) ?? null}
              renderInput={(params) =>
                <TextField
                  {...params}
                  label="Grupo Contábil"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  required={isRequired}
                />}
              onChange={autoCompleteChange}
              fullWidth
              disabled={isDisabled}
              required={isRequired}
            />
          </>
        )
      }
    </>
  );
};


SelectGrupoContabil.propTypes = {
  setValues: PropTypes.func.isRequired,
  accountGroup: PropTypes.oneOfType([
    PropTypes.shape(AccountGroupPropTypes),
    PropTypes.arrayOf(PropTypes.shape(AccountGroupPropTypes)),
    PropTypes.oneOf([null, undefined]),
  ]),
  isDelete: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
}

SelectGrupoContabil.defaultProps = {
  accountGroup: null,
  isRequired: true,
};

export default SelectGrupoContabil;